/* eslint-disable camelcase */
// Parse headers into an object

const ignoreDuplicateOf = [
  'age',
  'authorization',
  'content-length',
  'content-type',
  'etag',
  'expires',
  'from',
  'host',
  'if-modified-since',
  'if-unmodified-since',
  'last-modified',
  'location',
  'max-forwards',
  'proxy-authorization',
  'referer',
  'retry-after',
  'user-agent'
];

interface HeaderProps {
  [ket: string]: any;
}

export function parseHeaders(headers: string) {
  const parsed: HeaderProps = {};
  let key, val, i;

  if (!headers) {
    return parsed;
  }

  const headerArr = headers.split('\n');

  // trim 是否需要polyfill
  // function trim(str: string) {
  //   return str.replace(/^\s*/, '').replace(/\s*$/, '');
  // }

  headerArr.forEach((element) => {
    i = element.indexOf(':');
    key = element.substr(0, i).trim().toLowerCase();
    val = element.substr(i + 1).trim();
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        // eslint-disable-next-line prefer-template, @typescript-eslint/restrict-plus-operands
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
}

export const formatUrl = (url: string) => {
  try {
    if (!url) {
      return '';
    }
    if (url.startsWith('http')) {
      const path = new URL(url).pathname;
      return path;
    }
  } catch (error) {}
  return url;
};

/**
 * 判断是否通过公钥加签，后期需要直接下线
 * @param ts_sign
 * @returns
 */
export const isPublishKeySign = (tsSign: string) => {
  if (tsSign) {
    return tsSign.startsWith('ts.1');
  }
  // 默认处理成是
  return true;
};

/**
 * 判断当前证书是老版还是新版
 * @param cert 当前获取的证书
 * @returns boolean
 */
export const checkCertIsNewVersion = (cert?: string) => {
  if (!cert) {
    return false;
  }
  // fix: 不分safari场景下会报错，可能返回的不是string
  if (typeof cert === 'string' && cert.indexOf('pub.') !== -1) {
    return true;
  }
  return false;
};
